<template>
  <section id="suggestion" class="hotelSection white Suggestion">
    <div class="hotelSectionInner">
      <h3 class="hotelH3">こちらもおすすめ</h3>

      <div class="hotelRecommendBox">
        <ul class="hotelRecommendList">
          <recommend-hotel-card
            v-for="(hotel, idx) in hotels"
            :key="idx"
            :name="hotel.name"
            :price="hotel.price"
            :star-number="hotel.starNumber"
            :person-number="hotel.personNumber"
            :stay-day="hotel.stayDay"
            :image-url="hotel.imageUrl"
            :link="hotel.link"
          />
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import RecommendHotelCard from './RecommendHotelCard.vue'

export default {
  name: 'TkRecommendHotelList',
  components: {
    RecommendHotelCard,
  },
  props: {
    hotels: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style lang="scss">
@import '~@ota-frontend/ui/src/scss/components/TkRecommendHotelList.scss';
</style>
